import React from "react";
/**
 * Estado vacío con icono, mensaje y CTA opcional.
 */
export default function EmptyState({ message, actionLabel, onAction, icon, title, }: {
    message: React.ReactNode;
    actionLabel?: string;
    onAction?: () => void;
    icon?: React.ReactNode;
    title?: React.ReactNode;
}): any {
    const Icon = icon ?? (<svg className="w-12 h-12 text-fg-subtle" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
    </svg>);
    return (<div className="py-12 px-4 text-center">
      <div className="flex justify-center mb-3">{Icon}</div>
      {title != null && title !== "" && (<p className="text-fg text-sm font-semibold mb-1">{title}</p>)}
      <p className="text-fg-muted text-sm mb-4">{message}</p>
      {actionLabel && onAction && (<button type="button" onClick={onAction} className="rounded-lg bg-brand-700 px-4 py-2 text-sm font-medium text-fg-on-brand hover:bg-brand-800 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 active:scale-[0.98]">
          {actionLabel}
        </button>)}
    </div>);
}
